import { __assign } from "tslib";
import get from 'lodash/get';
export function getMultiChatStackInfo(chatroom, currentUser) {
    var _a, _b, _c;
    // Multi chat
    // Here we have special backend data to parse
    // name is comma separated username E.g. muteor,chris
    // initials is comma separated symbols E.g. admin,admin
    // image is comma separated icons (first two only)
    var usernames = (_a = chatroom.name) === null || _a === void 0 ? void 0 : _a.split(',');
    var types = (_b = chatroom.initials) === null || _b === void 0 ? void 0 : _b.split(',');
    var thumbs = (_c = chatroom.thumbnail) === null || _c === void 0 ? void 0 : _c.split(',');
    if (!usernames || !types || !thumbs) {
        return [];
    }
    if (usernames.length !== types.length) {
        return [];
    }
    var displayDataForIndex = function (index) {
        return usernames[index] &&
            toDisplayData({
                name: usernames[index],
                initials: types[index],
                image: { url: thumbs[index] },
            });
    };
    // Remove current user from lists, as it's implied we're in all conversations
    var ownUserIndex = usernames.indexOf(currentUser.username);
    usernames.splice(ownUserIndex, 1);
    types.splice(ownUserIndex, 1);
    thumbs.splice(ownUserIndex, 1);
    // Try to get the last message sender. We'll show that one first.
    // Sometimes we get a WixChatEntry object, sometimes it's an WixChatroom. Such is life.
    var lastSender;
    if (chatroom.lastMessage) {
        lastSender = toDisplayData(get(chatroom, 'lastMessage.senderDisplayData'));
    }
    else {
        var messages = chatroom.messages;
        lastSender = toDisplayData(get(messages[messages.length - 1], 'senderDisplayData'));
    }
    var infoStack = [];
    // Use last sender when we can, but not if the last sender is current user
    if (lastSender && lastSender.displayData.name !== currentUser.username) {
        infoStack.push(lastSender);
    }
    for (var i = 0, t = usernames.length; i < t; i++) {
        if (lastSender && lastSender.displayData.name === usernames[i]) {
            continue;
        }
        infoStack.push(displayDataForIndex(i));
    }
    return infoStack.filter(function (item) { return Boolean(item); });
}
export function toDisplayData(data, options) {
    if (options === void 0) { options = {}; }
    var _a = options.includeUserSymbol, includeUserSymbol = _a === void 0 ? true : _a;
    if (!data) {
        return data;
    }
    return {
        id: '',
        displayData: __assign(__assign({}, data), { 
            // Empty string to avoid an error where this ends up getting put through
            // `getUserTypeId`: projects/da-shared-react/src/User/helpers.ts
            initials: includeUserSymbol ? data.initials : '' }),
    };
}
//# sourceMappingURL=helpers.js.map